import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'
import { defineAsyncComponent } from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: {
  name: {
    type: String,
    required: true
  },
},
  setup(__props) {

const props = __props



// const icon = defineAsyncComponent(() => import(`@/assets/icons/${props.name}.svg`));
const icon = computed(() => {
  props.name // Trigger the name as a dependency for change detection
  return defineAsyncComponent(() => import('@/assets/icons/' + props.name + '.svg'))
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(icon)), {
    class: _normalizeClass(["UIIcon", `UIIcon--${__props.name}`])
  }, null, 8, ["class"]))
}
}

})